import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Col, Form, Modal, notification, Radio, Row, Select } from 'antd'
import configuration from 'modules/configuration'
import { generateMessageError, generateSelectOptions } from 'modules/core/utils'
import AddAndDeleteFormItem from '../AddAndDeleteFormIntem/AddAndDeleteFormItem'

const PreferencesTableModal = ({
  visible,
  onClose,
  onRefresh,
  setShowPreferenceModal,
  allDimensionsList,
  updateDisplaySettings,
  fetchDisplaySettings,
  displaySettings,
}) => {
  const [isSaving, setIsSaving] = useState(false)
  const [dimensionId, setDimensionId] = useState(null)
  const [form] = Form.useForm()
  const { t } = useTranslation()

  useEffect(() => {
    if (dimensionId) {
      fetchDisplaySettings({ id_dimension: dimensionId })
    }
  }, [fetchDisplaySettings, dimensionId])

  useEffect(() => {
    if (dimensionId) {
      form.setFieldsValue({
        dimensions: form.getFieldsValue().dimensions.map((el) => {
          if (el.id_dimension === dimensionId) {
            return {
              ...el,
              type_data_view: displaySettings?.type_view_data,
            }
          }
          return el
        }),
      })
    }
  }, [dimensionId, form, displaySettings.type_view_data, displaySettings.id])

  const onCloseModal = () => {
    form.resetFields()
    onClose()
    setIsSaving(false)
    setShowPreferenceModal(false)
  }

  const handleSave = () => {
    setIsSaving(true)
    form.validateFields().then((values) => {
      Promise.all(values.dimensions.map((el) => updateDisplaySettings(el.id_dimension, { ...el })))
        .then(() => {
          onRefresh()
          notification.success({
            message: t('FEEDBACK_CHANGES_SAVED_SUCCESS'),
            duration: 8,
          })
          onCloseModal()
        })
        .catch((error) => {
          notification.error({
            message: t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(error),
            duration: 0,
          })
          onCloseModal()
        })
    })
  }

  return (
    <Modal
      visible={visible}
      onCancel={onCloseModal}
      okText={t('ACTION_SAVE')}
      cancelText={t('ACTION_CANCEL')}
      title={t('DISPLAY_MODAL_SETTINGS_TITLE')}
      onOk={() => handleSave()}
      okButtonProps={{ loading: isSaving }}
      cancelButtonProps={{ disabled: isSaving }}
    >
      <Form form={form} layout="vertical" initialValues={{ dimensions: [''] }}>
        <Form.List name="dimensions">
          {(fields, { add, remove }) => {
            return (
              <div>
                {fields.map((field, index) => {
                  return (
                    <div key={field.key}>
                      <Row gutter={[24, 24]} key={field.key} justify="end">
                        <Col span={24}>
                          <Form.Item
                            name={[field.name, 'id_dimension']}
                            label={[field.label, t('LABEL_DIMENSIONS')]}
                            rules={[
                              {
                                required: true,
                                message: t('REQUIRED_FIELD'),
                              },
                            ]}
                          >
                            <Select
                              placeholder={t('ACTION_SELECT')}
                              onChange={(id) => {
                                setDimensionId(id)
                              }}
                              options={generateSelectOptions({
                                options: allDimensionsList.map((el) => {
                                  return {
                                    id: el.id,
                                    name: el.name_destination,
                                    code: el.code_destination,
                                  }
                                }),
                              })}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Form.Item
                            name={[field.name, 'type_data_view']}
                            label={[field.label, t('CONFIG_SETTINGS_MODAL_TEXT')]}
                            rules={[
                              {
                                required: true,
                                message: t('REQUIRED_FIELD'),
                              },
                            ]}
                          >
                            <Radio.Group>
                              {[
                                {
                                  key: 'code_and_name',
                                  description: t('CONFIG_SETTINGS_OPTION_BOTH'),
                                },
                                { key: 'code', description: t('CONFIG_SETTINGS_OPTION_CODE') },
                                { key: 'name', description: t('CONFIG_SETTINGS_OPTION_NAME') },
                              ].map((option) => (
                                <Radio
                                  key={option.key}
                                  value={option.key}
                                  style={{
                                    display: 'block',
                                    height: '30px',
                                    lineHeight: '30px',
                                  }}
                                >
                                  {option.description}
                                </Radio>
                              ))}
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                        <AddAndDeleteFormItem
                          fieldsLength={fields.length}
                          index={index}
                          addData={{
                            onClick: () => add(),
                            buttonName: 'ACTION_ADD_NEW',
                          }}
                          deleteData={{
                            onClick: () => {
                              remove(field.name)
                            },
                            buttonName: 'ACTION_DELETE',
                          }}
                        />
                      </Row>
                    </div>
                  )
                })}
              </div>
            )
          }}
        </Form.List>
      </Form>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  displaySettings: configuration.selectors.getDisplaySettings(state),
})

const mapDispatchToProps = {
  updateDisplaySettings: configuration.actions.updateDisplaySettings,
  fetchDisplaySettings: configuration.actions.fetchDisplaySettings,
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferencesTableModal)
